module.exports = __webpack_public_path__ + "static/media/report.a10983eb.svg";